/** 与 App `helpCustomerData` 条目 id 一一对应 */
export const HELP_ARTICLE_IDS = [
  'info-security',
  'company-intro',
  'account-type',
  'cost-algorithm',
  'invite-code',
  'deposit-flow',
  'deposit-guide',
  'hk-edda',
  'icbc-hk-transfer',
  'cmbc-hk-transfer',
  'us-fees',
  'hk-fees',
  'cn-connect-fees',
  'us-option-fees',
  'hk-option-fees',
  'order-type-detail',
  'yield-rate',
  'estimated-cash',
  'securities-assets',
  'securities-pnl',
  'us-position-ref-price',
  'us-quotes',
  'us-market-rules',
  'us-extended-hours',
  'us-ipo',
  'us-fractional',
  'hk-quotes',
  'hk-trade-rules',
  'hk-grey-market',
  'hk-session-options',
  'hk-ipo',
  'cn-trade-rules',
  'cn-trade-scope',
  'cn-trade-hours',
  'cn-quote-unit',
  'cn-order-unit',
  'transfer-in',
  'transfer-out',
  'app-update-guide',
  'account-deletion',
  'fund-security',
  'faq',
  'compliance',
] as const;

export type HelpArticleId = (typeof HELP_ARTICLE_IDS)[number];

export function isHelpArticleId(id: string | undefined | null): id is HelpArticleId {
  if (!id) return false;
  return (HELP_ARTICLE_IDS as readonly string[]).includes(id);
}

export function resolveHelpArticleHtmlUrl(articleId: string): string {
  const base = import.meta.env.BASE_URL || '/';
  const normalizedBase = base.endsWith('/') ? base : `${base}/`;
  return new URL(`h5/help-articles/${articleId}.html`, normalizedBase).toString();
}
